import { render, staticRenderFns } from "./ReviewPremiumHeader.vue?vue&type=template&id=834adc26&scoped=true&"
import script from "./ReviewPremiumHeader.vue?vue&type=script&lang=js&"
export * from "./ReviewPremiumHeader.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPremiumHeader.vue?vue&type=style&index=0&id=834adc26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834adc26",
  null
  
)

export default component.exports